﻿$.fn.dxCtrlGridAdresseEmailListeNoire = function custom_dxCtrlGridAdresseEmailListeNoire(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlgridadresseemaillistenoire dx-ctrl");
        this.createInstance(new cdxCtrlGridAdresseEmailListeNoire(this, option));
    }
    return this;
}

window.cdxCtrlGridAdresseEmailListeNoire = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.context_grid == 'undefined') option.context_grid = "gridlistenoiregeneralemail"

    var dxGrid = null
    function mConstruit() {
        container.empty();

        container.css("height", "100%")

        var lstField = mGetLstField()
        var opt = {
            bddCtrl: option.bddCtrl,
            noDataText: "Aucun email en désinscription",
            typeData: "lstlistenoireadresseemail",
            lstTypeGrille: ["Lignes"],
            getItemTemplateHeight: function (typeGrille) { return ((typeGrille == "Lignes") ? 55 : 121) },
            lstLstConditionBase: option.lstLstConditionBase,
            context_grid: option.context_grid,
            itemTemplateGrille: itemTemplateGrille,
            itemTemplateGrillePlus: itemTemplateGrillePlus,
            nomTemplateIco: "email_liste_noire",
            itemsToolbar: mGetLstButtonToolBar(),
            onDisplayButtonLigne: mGetLstButtonLigne,
            onClickDataGrid: function (container, dataGrid, dataTemplate) {
                if (typeof dataTemplate.strcon == 'undefined') {
                    //pas de strcon, on affiche un message
                    mNotify("Ce mail n'est lié à aucune fiche", "warning", 3000)
                } else {
                    //on affiche le strcon
                    var table = option.bddCtrl.table.mGetItem(dataTemplate.strcon.id_table)
                    option.bddCtrl.getObjet(table.nom, dataTemplate.strcon.id).mShowPopup()
                }
            },
            onEndClickDataGrid: option.onEndClickDataGrid,
            fields: lstField,
            allowCarto: false,
            allowFilter: true,
            allowLucene: true,
            allowCheck: false,
            allowToolbar: option.allowToolbar,
            allowDeleteInToolbar: false,
            showColumnHeaders: option.showColumnHeaders,
            lstIdTableIdExclu: option.lstIdTableIdExclu,
            lstIdTableIdInclu: option.lstIdTableIdInclu
        }

        dxGrid = $("<div/>").appendTo(container).dxCtrlVirtualGrid(opt).dxCtrlVirtualGrid("instance")
    }

    function itemTemplateGrille(contentElement, dataTemplate, type) {
        var $Table = $("<table style='width:100%;height:100%;table-layout:fixed;'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var $TdAdresseEmail = $("<td style='width:30%;padding:0 3px;white-space:nowrap;font-family:barlow condensed;text-overflow:ellipsis;overflow:hidden;'><u>" + dataTemplate.email_liste_noire.adresse_email + "</u></td>").appendTo($Tr)

        var $TdStrCon = $("<td style='padding:0 5px;width:70%;'/>").appendTo($Tr)
        if (typeof dataTemplate.strcon == "undefined") {
            $TdStrCon.html("<span style='opacity:0.3;'>Aucune fiche pour l'adresse email</span>")
        } else {
            $TdStrCon.addClass('state-hover2')
            if (dataTemplate.strcon.id_historique_sup) $TdStrCon.css({
                "text-decoration": "line-through",
                "opacity": "0.3"
            })
            var table = option.bddCtrl.table.mGetItem(dataTemplate.strcon.id_table_key)
            var obj = option.bddCtrl.getObjet(table.nom)
            var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo($TdStrCon)
            var $Tr = $("<tr/>").appendTo($Table)
            var $TdICone = $("<td style='width:20px;padding:0 3px;'/>").appendTo($Tr)
            obj.mGetIcone(dataTemplate.strcon).appendTo($TdICone)
            var $TdImage = $("<td style='width:20px;padding:0 3px;'/>").appendTo($Tr)
            $("<div style='width:18px;height:18px;border-radius:50%;'/>").appendTo($TdImage).dxCtrlImgSimpleStrConUti({
                bddCtrl: option.bddCtrl,
                idTable: table.id_table,
                id: dataTemplate.strcon.id_key,
                dataTemplate: option.dataTemplate,
                text: ""
            })
            var $TdLib = $("<td style='width:100%;padding:0 3px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:bold;'/>").appendTo($Tr)
            $TdLib.text(obj.objetMetier.mGetLibNomPrenomFromDataTemplate(dataTemplate.strcon))
            $TdStrCon.attr("title", "Ouvrir la fiche<br/>" + obj.objetMetier.mGetLibNomPrenomFromDataTemplate(dataTemplate.strcon))
            $TdStrCon.on("click", function (e) { e.stopPropagation(); option.bddCtrl.getObjet(table.nom, dataTemplate.strcon.id_key).mShowPopup() })
        }
    }
    function itemTemplateGrillePlus(contentElement, dataTemplate) {
        var $Span = $("<span style=''><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataTemplate.email_liste_noire.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)
        $Span.attr("title", dataTemplate.email_liste_noire.dcr.toFrenchDateTime())
    }

    function mGetLstField() {
        var lst = []

        lst = lst.concat([{
            name: "dcr",
            dataField: "dcr",
            caption: "Date désincription",
            icon: "fas fa-clock",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "date",
            filterProperty: {
                filterOperations: ["=", "<>", "<", ">", "<=", ">=", "between", "isblank", "isnotblank", "superieurouegaletoday", "inferieurouegaletoday"]
            },
            calculateGroupValue: function (rowData) {
                return rowData.dcr.toGrpDate().id
            },
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-clock-rotate-left dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Désinscription: " + options.data.key.getGroupDateLibelle() + " (" + tot + ")")
            },
            groupIndex: 0,
            sortOrder: "desc",
            filterLinkGrp: "dcr_tri"
        }, {
            name: "dcr_tri",
            dataField: "dcr_tri",
            dataType: "date",
            allowGrid: true,
            visible: false
        }, {
            name: "adresse_email",
            dataField: "adresse_email",
            caption: "Adresse email",
            icon: "fas fa-at",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: false,
            allowSorting: true,
            dataType: "string"
        }, {
            name: "id_com_email_envoi",
            dataField: "id_com_email_envoi",
            caption: "id_com_email_envoi",
            icon: "fas fa-clock",
            allowFilter: false,
            allowGrid: false,
            allowGrouping: false,
            allowSorting: false,
            dataType: "number"
        }])

        return lst
    }

    function mGetLstButtonToolBar() {
        var items = []
        items.push({
            location: 'before',
            template: function (itemData, itemIndex, itemElement) {
                $("<div/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-bars-staggered",
                    icon2: "fas fa-ellipsis",
                    colorIcone2: theme.colorBtIcon2,
                    opacityIcone2: "0.9",
                    hint: "Afficher la grille structures/contacts des fiches en liste noire",
                    onClick: function (e) {
                        var xlstIdTableId = ""
                        dxGrid.mGetLstTraitementData().forEach(function (dataGrid) {
                            xlstIdTableId += ((xlstIdTableId.length > 0) ? "," : "") + dataGrid.id
                        })
                        if (xlstIdTableId.length > 0) {
                            //option.bddCtrl.mAjaxCall({ command: "getdatas", nomtable: "lst", sql: "select distinct champ_table_email.id_table,champ_table_email.id from email_liste_noire INNER JOIN champ_table_email ON champ_table_email.valeur=email_liste_noire.adresse_email where id_email_liste_noire in (" + xlstIdTableId + ")" }, function (data) {
                            option.bddCtrl.mAjaxCall({ command: "getdatasemaillistenoire", nomtable: "lst", lstid: xlstIdTableId }, function (data) {
                                data.lstemailistenoire = JSON.parse(data.lstemailistenoire)
                                //if (typeof data.lstemailistenoire == 'undefined') data.lstemailistenoire = []
                                if (data.lstemailistenoire.length > 0) {
                                    page.mAddPopupLst("Liste des désinscriptions emails" + ((typeof option.objet == 'undefined') ? "" : " &bull; " + option.objet), function (contentElement) {
                                        $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlPopupLstStrConTempo({
                                            bddCtrl: option.bddCtrl,
                                            lstIdTableIdInclu: data.lstemailistenoire
                                        })
                                    })
                                } else { mNotify("Aucune fiche à afficher", "warning", 6000) }
                            })
                        } else { mNotify("Aucune fiche à afficher", "warning", 6000) }
                    }
                }).dxCtrlButton("instance")
            }
        })
        //if (typeof option.showBtNew == 'undefined' || option.showBtNew) {
        //    items.push({
        //        location: 'before',
        //        template: function (itemData, itemIndex, itemElement) {
        //            $("<div/>").appendTo(itemElement).dxCtrlButton({
        //                icon: "fas fa-envelope",
        //                icon2: "fas fa-certificate",
        //                colorIcone2: theme.colorBtIcon2,
        //                opacityIcone2: "0.9",
        //                txtTooltip: "Nouvel email",
        //                onClick: function (e) {
        //                    option.bddCtrl.getObjet("com_email_envoi").objetMetier.mShowNewEmail()
        //                }
        //            }).dxCtrlButton("instance")
        //        }
        //    })
        //    items.push({
        //        location: 'before',
        //        template: function (itemData, itemIndex, itemElement) {
        //            $("<div/>").appendTo(itemElement).dxCtrlButton({
        //                icon: "fas fa-square-envelope",
        //                icon2: "fas fa-certificate",
        //                colorIcone2: theme.colorBtIcon2,
        //                opacityIcone2: "0.9",
        //                txtTooltip: "Nouvel emailing",
        //                onClick: function (e) {
        //                    option.bddCtrl.getObjet("com_email_envoi").objetMetier.mShowNewEmail(true)
        //                }
        //            }).dxCtrlButton("instance")
        //        }
        //    })
        //    items.push({
        //        location: 'before',
        //        template: function (itemData, itemIndex, itemElement) {
        //            dxBtNewDocEmail = $("<div/>").appendTo(itemElement).dxCtrlButton({
        //                icon: "fas fa-file",
        //                icon2: "fas fa-certificate",
        //                colorIcone2: theme.colorBtIcon2,
        //                opacityIcone2: "0.9",
        //                icon3: "fas fa-at",
        //                colorIcone3: theme.color,
        //                leftIcone3: true,
        //                txtTooltip: "Nouveau document email",
        //                onClick: function (e) {
        //                    (new cObjetFichierEmlzMetier(null, option.bddCtrl)).mShowNewDocumentEmail()
        //                }
        //            }).dxCtrlButton("instance")
        //        }
        //    })
        //}
        return items
    }

    function mGetLstButtonLigne(toolbar, dataGrid, dataTemplate) {

    }

    this.mChangeLstIdTableIdExclu = function (lstId) {
        dxGrid.mChangeLstIdTableIdExclu(lstId)
    }
    this.mChangeLstIdTableIdInclu = function (lstId) {
        dxGrid.mChangeLstIdTableIdInclu(lstId)
    }

    this.element = function () { return container }

    mConstruit();
}